//DEFAULTS
import "imports/core-js/stable";
import "imports/regenerator-runtime/runtime";

//import overlay from 'site/overlay'
import site from 'site/site'
import home from 'site/home'
import global from 'site/global'
import siteScroll from 'site/scroll'
import mobileNav from 'site/mobileNav'
import mobileSubNav from 'site/mobileSubNav'
import siteAOS from 'site/site.aos'
$(document).ready(function() {
    mobileNav.init()
    mobileSubNav.init()
    site.init()
    global.init()
    siteScroll.init()
    home.init()
    setTimeout( function() {
        siteAOS.init()
        siteAOS.refreshAOS()
    },500)
})
